<template>
  <component
    :is="tag"
    :class="classes"
    :style="style"
    @click="emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { resolveThemeColor } from './themeColor'

/**
 * UiCard — Vuetify <v-card> replacement. Plain elevated surface;
 * `outlined` uses a border instead of shadow.
 */
const props = withDefaults(
  defineProps<{
    outlined?: boolean
    flat?: boolean
    color?: string
    dark?: boolean
    tag?: string
  }>(),
  { outlined: false, flat: false, color: undefined, dark: false, tag: 'div' },
)

const emit = defineEmits<(e: 'click', event: MouseEvent) => void>()

const classes = computed(() =>
  [
    'rounded-lg',
    'border',
    props.outlined || props.flat ? '' : 'shadow-sm',
    props.outlined ? 'border-gray-200 bg-white' : '',
    !props.outlined && !props.flat ? 'border-transparent bg-white' : '',
    props.dark ? 'text-white' : '',
  ].join(' '),
)

const style = computed(() => {
  const c = resolveThemeColor(props.color)
  return c != null ? { backgroundColor: c } : {}
})
</script>
